import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.buyBar.BuyBarItemMobileNoStock';

export const BuyBarItemMobileNoStock = ({ isCrawler = false }: { isCrawler?: boolean }) => (
  <BuyBarItemMobileNoStock.NoStock $isCrawler={isCrawler}>
    <BuyBarItemMobileNoStock.Size>{t(`${TP}.allSizes`, 'All Sizes')}</BuyBarItemMobileNoStock.Size>
    <BuyBarItemMobileNoStock.OutOfStock data-qa="buy_bar_oos">
      {t(`${TP}.outOfStock`, 'Currently Unavailable')}
    </BuyBarItemMobileNoStock.OutOfStock>
  </BuyBarItemMobileNoStock.NoStock>
);

BuyBarItemMobileNoStock.NoStock = styled.div<{ $isCrawler: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isCrawler }) => ($isCrawler ? 'flex-start' : 'center')};

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    color: ${({ theme }) => theme.colors.white};
  }
`;

BuyBarItemMobileNoStock.Size = styled.div`
  margin-bottom: 4px;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '20px', size: '18px' })};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })};
  }
`;

BuyBarItemMobileNoStock.OutOfStock = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '16px', size: '11.5px' })};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })};
  }
`;
